import { ReactNode, useState } from 'react';
import { EXPORT_REQUEST_KEY, ExportRequestContext } from './context';

export const ExportRequestContextProvider = ({ children }: { children?: ReactNode }) => {
  const [exportRequestKey, setExportRequestKey] = useState(localStorage.getItem(EXPORT_REQUEST_KEY) || null);
  const [isExportFailed, setIsExportFailed] = useState(false);
  const [isConcurrencyError, setIsConcurrencyError] = useState(false);

  return (
    <ExportRequestContext.Provider
      value={{
        exportRequestKey,
        setExportRequestKey,
        isExportFailed,
        setIsExportFailed,
        isConcurrencyError,
        setIsConcurrencyError,
      }}
    >
      {children}
    </ExportRequestContext.Provider>
  );
};
